import { Spend } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import type { Quota } from '../../../domain/quota';
import { translate } from '../../../services/i18n';
import { formatCompactNumber } from '../../../services/numberFormat';
import { quotaI18nKeys } from '../i18n';

import { StyledMainText, StyledQuotaText } from './styles';

type Props = {
  quota: Quota;
};

export const QuotaLeftText = ({ quota }: Props) => {
  return (
    <StyledQuotaText>
      <Spend size={16} color={colorsPalettes.carbon[400]} />

      <StyledMainText data-automation="Credits">
        {translate(quotaI18nKeys.dataCreditsLeft, {
          quota: formatCompactNumber(Math.max(0, quota.remaining)),
        })}
      </StyledMainText>
    </StyledQuotaText>
  );
};
